export enum VideoSources {
  Computer = 'computer',
  Youtube = 'youtube',
  Vimeo = 'vimeo',
  Facebook = 'facebook',
  Live = 'live',
}
